function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#3E6FB7",
  "data-svg-class": "Stroke"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5 5.5V5A1.5 1.5 0 0018 3.5H9.191l-1.5-3H2A1.5 1.5 0 00.5 2v12c0 .472.22.9.57 1.178.013-.053.027-.106.044-.16L3.39 7.685C3.769 6.464 5.073 5.5 6.348 5.5H19.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M5.348 5.5c-.837 0-1.754.678-2.003 1.482l-2.276 7.333c-.215.691.147 1.185.865 1.185h15.29c.837 0 1.754-.678 2.003-1.482l2.276-7.333c.215-.691-.147-1.185-.865-1.185H5.348z"
}));

function SvgMediaUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaUploadFile);
export default __webpack_public_path__ + "static/media/MediaUploadFile.cb1d921a.svg";
export { ForwardRef as ReactComponent };